/**
 * SmartGaz Domain Constants & Enums
 */

export const ORDER_STATUS = {
  PENDING: 'PENDING',
  ASSIGNED: 'ASSIGNED',
  ON_WAY: 'ON_WAY',
  ARRIVED: 'ARRIVED',
  DELIVERING: 'DELIVERING',
  COMPLETED: 'COMPLETED',
  SKIPPED: 'SKIPPED',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
};

export const ORDER_STATUS_MAP = {
  [ORDER_STATUS.PENDING]: {
    label: 'Kutilmoqda',
    color: 'amber',
    icon: 'schedule',
  },
  [ORDER_STATUS.ASSIGNED]: {
    label: 'Biriktirildi',
    color: 'blue',
    icon: 'assignment_ind',
  },
  [ORDER_STATUS.ON_WAY]: {
    label: 'Yo\'lda',
    color: 'blue',
    icon: 'local_shipping',
  },
  [ORDER_STATUS.ARRIVED]: {
    label: 'Yetib keldi',
    color: 'emerald',
    icon: 'location_on',
  },
  [ORDER_STATUS.DELIVERING]: {
    label: 'Topshirilmoqda',
    color: 'emerald',
    icon: 'gas_meter',
  },
  [ORDER_STATUS.COMPLETED]: {
    label: 'Bajarildi',
    color: 'green',
    icon: 'verified',
  },
  [ORDER_STATUS.SKIPPED]: {
    label: 'Topilmadi',
    color: 'slate',
    icon: 'person_off',
  },
  [ORDER_STATUS.CANCELLED]: {
    label: 'Bekor qilindi',
    color: 'slate',
    icon: 'cancel',
  },
  [ORDER_STATUS.FAILED]: {
    label: 'Xatolik',
    color: 'red',
    icon: 'error',
  },
};

export const USER_ROLE = {
  ADMIN: 'ADMIN',
  DRIVER: 'DRIVER',
  OPERATOR: 'OPERATOR',
  USER: 'USER',
};

export const USER_ROLE_MAP = {
  [USER_ROLE.ADMIN]: {
    label: 'Admin',
    color: 'red',
    icon: 'admin_panel_settings',
  },
  [USER_ROLE.DRIVER]: {
    label: 'Haydovchi',
    color: 'blue',
    icon: 'local_shipping',
  },
  [USER_ROLE.OPERATOR]: {
    label: 'Operator',
    color: 'amber',
    icon: 'support_agent',
  },
  [USER_ROLE.USER]: {
    label: 'Mijoz',
    color: 'green',
    icon: 'person',
  },
};

export const ROUTE_STATUS = {
  CREATED: 'CREATED',
  ACTIVE: 'ACTIVE',
  IN_PROGRESS: 'IN_PROGRESS',
  DONE: 'DONE',
  CANCELLED: 'CANCELLED',
};

export const ROUTE_STATUS_MAP = {
  [ROUTE_STATUS.CREATED]: {
    label: 'Rejalashtirilgan',
    color: 'slate',
  },
  [ROUTE_STATUS.ACTIVE]: {
    label: 'Faol',
    color: 'amber',
  },
  [ROUTE_STATUS.IN_PROGRESS]: {
    label: 'Jarayonda',
    color: 'blue',
  },
  [ROUTE_STATUS.DONE]: {
    label: 'Yakunlandi',
    color: 'green',
  },
  [ROUTE_STATUS.CANCELLED]: {
    label: 'Bekor qilingan',
    color: 'red',
  },
};

export const TRANSACTION_TYPE = {
  TOPUP: 'TOPUP',
  PAYMENT: 'PAYMENT',
  REFUND: 'REFUND',
};

/** Navbat ustuvorligi (backend bilan bir xil) */
export const PRIORITY_LEVEL = {
  VIP: 1,
  BOOKING: 2,
  REGULAR: 3,
};

export const GAS_UNIT_PRICE = 20000;

/** StatusTimeline qadamlari uchun */
export const ORDER_STATUS_STEP = {
  [ORDER_STATUS.PENDING]: 0,
  [ORDER_STATUS.ASSIGNED]: 1,
  [ORDER_STATUS.ON_WAY]: 2,
  [ORDER_STATUS.ARRIVED]: 3,
  [ORDER_STATUS.DELIVERING]: 4,
  [ORDER_STATUS.COMPLETED]: 5,
  [ORDER_STATUS.SKIPPED]: 5,
  [ORDER_STATUS.CANCELLED]: 0,
  [ORDER_STATUS.FAILED]: 0,
};

export const FLEET_STATUS_MESSAGE = {
  NO_MAHALLA: 'Profilda mahallangizni tanlang',
  NO_ACTIVE_ROUTE: 'Hozircha faol gaz yetkazish yo\'q',
  MAHALLA_NOT_ON_ROUTE: 'Bugungi marshrut sizning mahallangizdan o\'tmaydi',
};

export const TRANSACTION_MAP = {
  [TRANSACTION_TYPE.TOPUP]: {
    label: 'Hisobni to\'ldirish',
    color: 'green',
    icon: 'add_circle',
  },
  [TRANSACTION_TYPE.PAYMENT]: {
    label: 'To\'lov',
    color: 'red',
    icon: 'remove_circle',
  },
  [TRANSACTION_TYPE.REFUND]: {
    label: 'Qaytarish',
    color: 'blue',
    icon: 'history',
  },
};
